import { DashboardAsset } from '../../../types/Dashboard'
import { getFlexTier } from '../../../utils/dashboardUtils'

type AssetDetailPanelProps = {
    asset: DashboardAsset
    onClose: () => void
}

export function AssetDetailPanel({ asset, onClose }: AssetDetailPanelProps) {
    const tier = getFlexTier(asset.flexCapacityKw)

    return (
        <div className="asset-detail-panel">
            <div className="asset-detail-header">
                <h5>{asset.name}</h5>
                <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
                    &times;
                </button>
            </div>
            <div className="asset-detail-body">
                <div className="asset-detail-row">
                    <span className="asset-detail-label">Location</span>
                    <span>{asset.location.lat.toFixed(2)}, {asset.location.lng.toFixed(2)}</span>
                </div>
                <div className="asset-detail-row">
                    <span className="asset-detail-label">Flex Capacity</span>
                    <span>{asset.flexCapacityKw} kW <span className={`badge bg-${tier === 'high' ? 'danger' : tier === 'medium' ? 'warning' : 'success'}`}>{tier}</span></span>
                </div>
                <div className="asset-detail-row">
                    <span className="asset-detail-label">Baseload</span>
                    <span>{asset.baseloadKw !== null ? `${asset.baseloadKw} kW` : 'No data'}</span>
                </div>
                <div className="asset-detail-row">
                    <span className="asset-detail-label">Current Flex Used</span>
                    <span>{asset.currentFlexUsedKw !== null ? `${asset.currentFlexUsedKw} kW` : 'No data'}</span>
                </div>
                <div className="asset-detail-row">
                    <span className="asset-detail-label">Programmes</span>
                    <span>{asset.programmes.join(', ')}</span>
                </div>
            </div>
        </div>
    )
}
